"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createMapper;

var _objectMapper = require("./object-mapper/object-mapper");

var _objectMapper2 = _interopRequireDefault(_objectMapper);

var _mapper = require("./mapper");

var _mapper2 = _interopRequireDefault(_mapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createMapper(options) {

  var opts = options || {};

  // flatten defaults to null which means will make the decision to flatten by itself
  var permittedOptions = ["flatten", "flattenInverted", "alwaysSet", "alwaysTransform"];
  var defaultValues = [null, false, false, false];

  for (var i = 0; i < permittedOptions.length; i++) {
    var option = permittedOptions[i];
    opts[option] = typeof opts[option] === "boolean" ? opts[option] : defaultValues[i];
  }

  var me = {
    mapper: new _mapper2.default(opts, _objectMapper2.default)
  };

  var mapper = function map(source) {

    return this.mapper.map(source);
  }.bind(me);

  mapper.map = function (source) {

    return this.mapper.map(source);
  }.bind(me);

  mapper.set = function (key, value) {
    return this.mapper.set(key, value);
  }.bind(me);

  mapper.execute = function (source, destination) {
    return this.mapper.execute(source, destination);
  }.bind(me);

  mapper.executeAsync = function (source, destination) {
    return this.mapper.executeAsync(source, destination);
  }.bind(me);

  mapper.each = function (sourceArray) {
    return this.mapper.each(sourceArray);
  }.bind(me);

  mapper.chain = function (secondaryMapper) {
    return this.mapper.chain(secondaryMapper);
  }.bind(me);

  return mapper;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/map-factory/dist/lib/map-factory.js
// module id = JU03
// module chunks = 9